import { LanguageList } from './LanguageList';

export const list = LanguageList;
